export const state = {
    //data
    editMyInfo: false,
    editMarket: false,
    merchantInfo: null,
};

export const getters = {
    editMyInfo: state => state.editMyInfo,
    editMarket: state => state.editMarket,
    merchantInfo: state => state.merchantInfo,
};

export const actions = {
    // methods
    // make call
    // never update a state
    editMyInfo(context, payload) {
        context.commit('editMyInfo', payload);
    },
    merchantInfo(context, payload) {
        context.commit('merchantInfo', payload);
    },
};

export const mutations = {
    //setting and updating state
    editMyInfo(state, payload) {
        state.editMyInfo = payload;
    },
    merchantInfo(state, payload) {
        state.merchantInfo = payload;
    },
};
